module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#photostory",
      toString: function () {
        return this.url;
      }
    }